const crossSessionParam = [
    'emailPreferences', // eloquaExtraData
    'contactFields', // eloquaExtraData
    'currentUserData', // extra call to CAD
    'heartbeat',
    'refCodeData',
    'eloquaExtraData',
];
/** is a param a valid crossSession param */
export const isCrossSessionParam = (param) => {
    return crossSessionParam.includes(param);
};
const userDataParams = [
    'currentUserData',
    'contactFields',
    'emailPreferences',
    'eloquaExtraData',
    'refCodeData',
];
/** check if the params are wanting to make a request for user data */
export const hasUserDataParam = (params) => {
    return params.some((param) => userDataParams.includes(param));
};
/** check if a param is one that will want user data */
export const isUserDataParam = (param) => {
    return userDataParams.includes(param);
};
